$(function () {
    var BLOCK_STARTS_DATA_KEY = "stems-pbe-block-starts";
    var BLOCK_ENDS_DATA_KEY = "stems-pbe-block-ends";
    var BLOCK_PRICE_DATA_KEY = "stems-pbe-block-price";
    var BLOCK_DATA_KEY = "stems-pbe-block";

    /**
     * Initializes the component
     * */
    var _init = function (editor) {
        var $addBtn = $(editor).find("[data-stems=price_block_editor_add]");
        var $infinityCheckBtn = _getInfiniteInput(editor);

        $addBtn.on("click", function () {
            _addNewBlock(editor);
        });

        $infinityCheckBtn.on("change", function () {
            var chkd = $(this).prop("checked");

            if (chkd) {
                $(this).parents("td").find(".fad").addClass("hidden");
                _getEndInput(editor).addClass("hidden");
            }
            else {
                $(this).parents("td").find(".fad").removeClass("hidden");
                _getEndInput(editor).removeClass("hidden");
            }
        });

        $(editor).on("click", "tbody td.cmd a", function (e, p) {
            var $table = $(this).parents("table");
            $(this).parents("tr").remove();
            _generateWarnings($table);
        });

        _getStartInput(editor).on("keyup", function () {
            _onInputEditing(editor);
        });

        _getEndInput(editor).on("keyup", function () {
            _onInputEditing(editor);
        });

        _getCostInput(editor).on("keyup", function () {
            _onInputEditing(editor);
        });
    }

    /**
     * Function that runs when an input is changed
     * @param {any} editor
     */
    var _onInputEditing = function (editor) {
        _toggleError(editor, false, null);
    }

    /**
     * Gets the starting block input element
     * @param {any} editor
     */
    var _getStartInput = function (editor) {
        return $(editor).find("[data-stems=price_block_editor_start]");
    }

    /**
     * Gets the ending block input element
     * @param {any} editor
     */
    var _getEndInput = function (editor) {
        return $(editor).find("[data-stems=price_block_editor_end]");
    }

    /**
     * Gets the cost input element
     * @param {any} editor
     */
    var _getCostInput = function (editor) {
        return $(editor).find("[data-stems=price_block_editor_cost]");
    }

    /**
     * Gets the IsInfinite input element
     * @param {any} editor
     */
    var _getInfiniteInput = function (editor) {
        return $(editor).find("input[type=checkbox]");
    }

    /**
     * Gets the table element
     * @param {any} editor
     */
    var _getTableElement = function (editor) {
        return $(editor).find("table");
    }

    /**
     * Adds and displays a new pricing block in UI
     * @param {any} editor
     * @param {any} newBlock
     */
    var _displayNewBlock = function (editor, newBlock) {

        var $blockCell = $("<td></td>");
        $blockCell.addClass("block");

        if (newBlock.isInfinite) {
            $blockCell.append(newBlock.startsAt + "+");
        }
        else {
            $blockCell.append(newBlock.startsAt + " - " + newBlock.endsAt);
        }

        var $startBlockInput = $("<input type='hidden' data-stems-pbe-type='StartingBlockInput' />");
        $startBlockInput.val(newBlock.startsAt);
        $blockCell.append($startBlockInput);

        var $endBlockInput = $("<input type='hidden' data-stems-pbe-type='EndingBlockInput' />");
        $endBlockInput.val(newBlock.isInfinite ? "" : newBlock.endsAt);
        $blockCell.append($endBlockInput);

        var $costCell = $("<td></td>");
        $costCell.addClass("cost");
        $costCell.append(newBlock.price.currency());

        var $costInput = $("<input type='hidden' data-stems-pbe-type='BlockPriceInput' />");
        $costInput.val(newBlock.price);
        $costCell.append($costInput);

        var $cmdCell = $("<td></td>");
        var $deleteBtn = $("<a><span class='fa fa-times'></span></a>");
        $deleteBtn.attr("title", "Remove");
        $deleteBtn.addClass("btn btn-sm btn-default btn-borderless");
        $deleteBtn.data(BLOCK_DATA_KEY, newBlock);
        $cmdCell.addClass("cmd");
        $cmdCell.append($deleteBtn);

        var $tr = $("<tr></tr>");
        $tr.data(BLOCK_STARTS_DATA_KEY, newBlock.startsAt);
        $tr.data(BLOCK_ENDS_DATA_KEY, newBlock.endsAt);
        $tr.data(BLOCK_PRICE_DATA_KEY, newBlock.price);
        $tr.data(BLOCK_DATA_KEY, newBlock);
        $tr.append($blockCell);
        $tr.append($costCell);
        $tr.append($cmdCell);

        var $table = _getTableElement(editor);
        $table.find("tbody").prepend($tr);

        var $trs = $table.find("tbody tr");
        var trs = $trs.toArray();
        $trs.detach();

        var sortedTrs = trs.sort(function (a, b) {
            return parseInt($(a).data(BLOCK_STARTS_DATA_KEY)) - parseInt($(b).data(BLOCK_STARTS_DATA_KEY));
        });

        $table.find("tbody").append(sortedTrs);
        $table.find("tbody tr input[data-stems-pbe-type=StartingBlockInput]")
            .each(function (idx, el) {
                $(el).attr("name", "PersonnelBlocks[" + idx + "].StartingBlock")
            });
        $table.find("tbody tr input[data-stems-pbe-type=EndingBlockInput]")
            .each(function (idx, el) {
                $(el).attr("name", "PersonnelBlocks[" + idx + "].EndingBlock")
            });
        $table.find("tbody tr input[data-stems-pbe-type=BlockPriceInput]")
            .each(function (idx, el) {
                $(el).attr("name", "PersonnelBlocks[" + idx + "].BlockPrice")
            });

        _generateWarnings($table);
    }

    /**
     * Retrieves the new block that is in edit mode
     * @param {any} editor
     */
    var _getNewBlock = function (editor) {
        var _block = {
            startsAt: 0,
            endsAt: null,
            price: 0.00,
            isInfinite: false
        }

        var startsAt = _getStartInput(editor).val();
        var endsAt = _getEndInput(editor).val();
        var cost = _getCostInput(editor).val();
        _block.isInfinite = _getInfiniteInput(editor).prop("checked");

        if (startsAt.toString().isInteger()) _block.startsAt = parseInt(startsAt);

        if (!_block.isInfinite) {
            if (endsAt.toString().isInteger()) _block.endsAt = parseInt(endsAt);
        }

        if (cost) _block.price = parseFloat(cost);

        return _block;
    }

    /**
     * Validates that the inputs have properly-formatted values
     * @param {any} editor
     * @returns
     */
    var _validateInputs = function (editor) {
        var result = { success: true, error: null };

        var $fromInput = _getStartInput(editor);
        var $toInput = _getEndInput(editor);
        var $priceInput = _getCostInput(editor);
        var $infiniteInput = _getInfiniteInput(editor);

        var fromVal = $fromInput.val();
        var toVal = $toInput.val();
        var priceVal = $priceInput.val();
        var isInfite = $infiniteInput.prop("checked");

        if (!fromVal || !fromVal.isInteger()) {
            result.success = false;
            result.error = "Invalid starting price block value";
        }

        if (!isInfite) {
            if (!toVal || !toVal.isInteger()) {
                result.success = false;
                result.error = "Invalid ending price block value";
            }
        }

        if (!priceVal || parseFloat(priceVal) < 0) {
            result.success = false;
            result.error = "Invalid price";
        }

        return result;
    }

    /**
     * Displays or hides the error alert container
     * @param {any} editor
     * @param {any} display
     * @param {any} message
     */
    var _toggleError = function (editor, display, message) {
        if (display && message) {
            $(editor).find(".alert.alert-danger").html(message).removeClass("hidden");
        }
        else {
            $(editor).find(".alert.alert-danger").html(message).addClass("hidden");
        }
    }

    /**
     * Adds a new price block to the table
     * @param {any} editor
     */
    var _addNewBlock = function (editor) {

        var valResult = _validateInputs(editor);

        if (!valResult || !valResult.success) {
            _toggleError(editor, true, valResult.error);
            return;
        }

        var newBlock = _getNewBlock(editor);

        _displayNewBlock(editor, newBlock);
        _clearInputs(editor);
    };

    /**
     * Removes the values from the input elements
     * @param {any} editor
     */
    var _clearInputs = function (editor) {
        _getStartInput(editor).val("");
        _getEndInput(editor).val("");
        _getCostInput(editor).val("");
        _getInfiniteInput(editor).prop("checked", false);
        _getInfiniteInput(editor).trigger("change");
    }

    /**
     * Analizes all pricing blocks and displays a warning message if there are
     * gaps or overlaps between blocks
     * @param {any} $table
     */
    var _generateWarnings = function ($table) {
        $(".pb-editor .alert.alert-warning").addClass("hidden");
        $(".pb-editor .alert.alert-warning").html("");

        var errors = [];
        var blocks = $table.find("tbody tr").map(function (index, element) {
            var b = $(element).data(BLOCK_DATA_KEY);
            if (!b) b = _scrapeBlock(element);
            return b;
        }).get();

        if (blocks.length < 1) {
            errors.push("At least one pricing block is required");
            return;
        }

        var sortedBlocks = blocks.sort(function (a, b) {
            return a.startsAt - b.startsAt;
        });

        if (sortedBlocks[0].startsAt != 1) {
            errors.push("The first pricing block must start with 1");
        }

        if (sortedBlocks.filter(function (b) {
            return b.isInfinite;
        }).length > 1) {
            errors.push("Multiple price blocks without an end value found");
        }

        var lastEndsAt = -1;
        for (var i = 0; i < sortedBlocks.length; i++){

            if (sortedBlocks[i].isInfinite && i < (sortedBlocks.length - 1)) {
                errors.push("Price blocks without an end value must always be the last block");
                break;
            }

            if (!sortedBlocks[i].isInfinite && sortedBlocks[i].startsAt > sortedBlocks[i].endsAt) {
                errors.push("Pricing blocks cannot end with a value smaller than starting value ("
                    + sortedBlocks[i].startsAt + "-" + sortedBlocks[i].endsAt + ")");
            }

            if (lastEndsAt != -1) {
                if ((lastEndsAt + 1) > sortedBlocks[i].startsAt) {
                    errors.push("Pricing blocks cannot overlap ("
                        + sortedBlocks[i].startsAt +
                        (sortedBlocks[i].isInfinite ? "+" : "-" + sortedBlocks[i].endsAt) + ")");
                }
                else if ((lastEndsAt + 1) < sortedBlocks[i].startsAt) {
                    errors.push("There's a gap in front of the '"
                        + sortedBlocks[i].startsAt +
                        (sortedBlocks[i].isInfinite ? "+" : "-" + sortedBlocks[i].endsAt) + "' pricing block");
                }
            }

            lastEndsAt = sortedBlocks[i].endsAt;
        }

        if (errors.length > 0) {
            var $ul = $("<ul></ul>");

            for (var i = 0; i < errors.length; i++) {
                var $li = $("<li></li>");
                $li.html(errors[i]);

                $ul.append($li);
            }

            $(".pb-editor .alert.alert-warning").append($ul);
            $(".pb-editor .alert.alert-warning").removeClass("hidden");
        }
    }

    /**
     * Obtains a block from HTML elements
     * @param {any} tr
     * @returns
     */
    var _scrapeBlock = function (tr) {
        var startsAtVal = $(tr).find("input[data-stems-pbe-type=StartingBlockInput]").val();
        var endsAtVal = $(tr).find("input[data-stems-pbe-type=EndingBlockInput]").val();
        var cost = $(tr).find("input[data-stems-pbe-type=BlockPriceInput]").val();

        return {
            startsAt: parseInt(startsAtVal),
            endsAt: endsAtVal ? parseInt(endsAtVal) : null,
            isInfinite: endsAtVal ? false : true,
            price: cost ? parseFloat(cost) : 0
        }
    }


    //runs initialization code
    $("[data-stems=price_block_editor]").each(function (idx, element) {
        _init(element);
    });
});